import React, { useEffect } from 'react'
import { SelectCP } from 'submodules/nerit-framework-ui/common/components/form-fields/select/SelectCP'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { FieldRegulationRequests } from 'submodules/nerit-aquatec-sdk/services/regulation/FieldRegulationRequests'
import { NameAndCodeResponseDTO } from 'submodules/nerit-framework-utils/sdk-utils/dtos/response/NameAndCodeResponseDTO'
import { ListResponseDTO } from 'submodules/nerit-framework-utils/sdk-utils/dtos/response/ListResponseDTO'

interface ICPProps {
    value?: number
    onChange: (fieldCode?: number) => void
    excludeFieldCode?: number
    errorMessage?: string
}

/**
 * Parâmetro de referência da formatação condicional (ex.: pH). Não oferece o próprio parâmetro da norma.
 */
export function SelectReferenceFieldCP(props: ICPProps): JSX.Element {

    const searchRequest = useRequest<ListResponseDTO<NameAndCodeResponseDTO>>()
    useEffect(onSearchRequestChange, [searchRequest.isAwaiting])

    useEffect(init, [])

    function init(): void {
        searchRequest.runRequest(FieldRegulationRequests.getFieldList())
    }

    function onSearchRequestChange(): void {
        RequestUtils.isValidRequestReturn(searchRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE)
    }

    const fields = (searchRequest.responseData?.list ?? [])
        .filter(field => field.code !== props.excludeFieldCode)
        .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'))

    return (
        <SelectCP
            label={'Parâmetro de Referência'}
            required={true}
            loading={searchRequest.isAwaiting}
            filterOption={true}
            options={fields.map(field => ({ value: field.code, label: field.name }))}
            value={props.value}
            onChange={props.onChange}
            errorMessage={props.errorMessage}
        />
    )
}
